import React, { useState, useRef, useEffect } from "react";
import { formatSoles } from "../../Global";

export function OrdenesCompraSelector({ 
  options = [], 
  onSeleccionChange, 
  className = "",
}) {
  const [seleccionado, setSeleccionado] = useState(null);
  const [abierto, setAbierto] = useState(false);
  const dropdownRef = useRef(null);

  const opcionNula = { IdOrdenCompra: null, nombre: "Sin información disponible", descripcion: null };
  
  const opcionesBase = options;
  const opcionesAUsar = [opcionNula, ...opcionesBase];

  const onChoose = (opcion) => {
    setSeleccionado(opcion.IdOrdenCompra);
    onSeleccionChange && onSeleccionChange(opcion);
    setAbierto(false);
  };

  const estaSeleccionado = (opcionId) => {
    return seleccionado === opcionId;
  };

  const obtenerOpcionSeleccionada = () => {
    return opcionesAUsar.find(op => op.IdOrdenCompra === seleccionado) || opcionNula;
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAbierto(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const opcionSeleccionada = obtenerOpcionSeleccionada();

  return (
    <div className={`${className} position-relative`} ref={dropdownRef}>
      <button
        type="button"
        className="d-flex justify-content-between align-items-center w-100"
        onClick={() => setAbierto(!abierto)}
        style={{
          textAlign: 'left',
          backgroundColor: '#fff',
          minHeight: '48px',
          padding: '8px 12px',
          transition: 'none',
          border: '1px solid #6c757d',
          borderRadius: '0.25rem',
          color: '#212529',
          outline: 'none',
          boxShadow: 'none'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#fff';
          e.currentTarget.style.color = '#212529';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#fff';
          e.currentTarget.style.color = '#212529';
        }}
      >
        {opcionSeleccionada.IdOrdenCompra ? (
          <div className="d-flex flex-column align-items-start w-100" style={{ pointerEvents: 'none' }}>
            <span className="font-weight-medium p-0 m-0" style={{ fontSize: '0.95rem', color: '#212529' }}>
              {opcionSeleccionada.Numero} | Fecha: {opcionSeleccionada.FechaEmision} | Total: S/ {formatSoles(opcionSeleccionada.Total)}
            </span>
            {opcionSeleccionada.NombreProveedor && (
              <small style={{ color: '#6c757d' }}>
                {opcionSeleccionada.NombreProveedor} - RUC: {opcionSeleccionada.RucProveedor}
              </small>
            )}
          </div>
        ) : (
          <span style={{ color: '#6c757d', pointerEvents: 'none' }}>{opcionSeleccionada.nombre}</span>
        )}
        <i className={`fas fa-chevron-${abierto ? 'up' : 'down'} ml-2`} style={{ color: '#212529', pointerEvents: 'none' }}></i>
      </button>

      {abierto && (
        <div
          className="border shadow-sm"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            marginTop: '4px',
            maxHeight: '300px',
            overflowY: 'auto',
            borderRadius: '0.375rem',
            backgroundColor: '#fff',
            zIndex: 1050
          }}
        >
          {opcionesAUsar.map((opcion) => {
            const seleccionado = estaSeleccionado(opcion.IdOrdenCompra);
            return (
              <button
                key={opcion.IdOrdenCompra}
                type="button"
                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                onClick={() => onChoose(opcion)}
                style={{
                  border: 'none',
                  borderBottom: '1px solid #dee2e6',
                  cursor: 'pointer',
                  padding: '10px 12px',
                  transition: 'none',
                  backgroundColor: seleccionado ? '#01A59C' : '#fff',
                  color: seleccionado ? '#fff' : '#212529'
                }}
              >
                {opcion.IdOrdenCompra ? (
                  <div className="d-flex flex-column align-items-start w-100">
                    <span className="font-weight-medium p-0 m-0" style={{ color: seleccionado ? '#fff' : '#212529' }}>
                      {opcion.Numero} | Fecha: {opcion.FechaEmision} | Total: S/ {formatSoles(opcion.Total)} {opcion.Glosa && `| Glosa: ${opcion.Glosa}`}
                    </span>
                    {opcion.NombreProveedor && (
                      <small style={{ color: seleccionado ? '#fff' : '#6c757d' }}>
                        {opcion.NombreProveedor} - RUC: {opcion.RucProveedor}
                      </small>
                    )}
                  </div>
                ) : (
                  <div className="d-flex flex-column align-items-start w-100">
                    <span className="font-weight-medium p-0 m-0" style={{ color: seleccionado ? '#fff' : '#212529' }}>
                      {opcion.nombre}
                    </span>
                  </div>
                )}
                
                {seleccionado && (
                  <i className="fas fa-check ml-2" style={{ color: '#fff' }}></i>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}